<template>
  <v-card
    class="mx-auto overflow-visible"
    width="800px"
    style="margin-top: 0px; margin-bottom: 0px;"
    outlined
  >
    <v-list-item three-line>
      <validation-observer v-slot="{ handleSubmit }">
        <v-list-item-content class="overflow-visible">
          <v-row class="align-center">
            <v-col cols="12" md="10">
              <v-list-item-title class="headline mb-2">Tìm kiếm nâng cao</v-list-item-title>
            </v-col>
            <v-col cols="12" md="2" class="text-right">
              <v-icon aria-label="Close" @click="closeMenu">mdi-close</v-icon>
            </v-col>
          </v-row>
          <div></div>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field placeholder="Nhập mã đơn hàng" v-model="filterForm.code" label="Mã đơn hàng" clearable />
            </v-col>
            <v-col cols="12" md="4">
              <common-range-picker
                :clearable="true"
                :aLight="'center'"
                label="Ngày tạo đơn"
                v-model="filterForm.createdAt"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="filterForm.paymentType"
                :items="paymentTypes"
                label="Phương thức thanh toán"
                placeholder="Chọn phương thức thanh toán"
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-select
                label="Tìm kiếm loại đơn (v1)"
                placeholder="Chọn loại đơn"
                :items="orderGroupType"
                item-value="id"
                item-text="name"
                v-model="filterForm.orderGroupType"
                clearable
              >

              </v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-select
                label="Giá trị (v1)"
                :items="typeOrderGroupPrice"
                item-text="name"
                item-value="id"
                v-model="filterForm.typeOrderGroupPrice"
                clearable
              >
              </v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                label="Giá trị đơn cọc (v1)"
                placeholder="Nhập giá trị đơn"
                v-model="filterForm.orderGroupPrice"
                clearable
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="filterForm.groupId"
                :items="productGroups"
                item-text="name"
                item-value="id"
                label="Nhóm sản phẩm (v1)"
                placeholder="Chọn nhóm sản phẩm"
                @change="onChangeProductGroup"
                @click:clear="clearProductGroup"
                clearable
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="filterForm.productId"
                :items="products"
                item-text="name"
                item-value="id"
                label="Sản phẩm (v1)"
                placeholder="Chọn sản phẩm"
                clearable
              />
            </v-col>
          </v-row>
          <div></div>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="filterForm.paymentPeriod"
                :items="paymentPeriods"
                item-text="name"
                item-value="id"
                label="Hình thức thanh toán (v2)"
                placeholder="Chọn hình thức thanh toán"
                clearable
              />
            </v-col>
          </v-row>
          <div></div>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                  v-model="filterForm.orderSaleMinistryIds"
                  :items="ministries"
                  item-text="name"
                  item-value="id"
                  label="Bộ phận"
                  placeholder="Chọn bộ phận"
                  @change="onChangeMinistry"
                  multiple
                  class="selectAll-group-product"
                  clearable
              >
                <template #prepend-item>
                  <common-select-all
                      v-model="filterForm.orderSaleMinistryIds"
                      :item="filterForm.orderSaleMinistryIds"
                      :items="ministries.map(s => s.id)"
                  ></common-select-all>
                </template>
              </v-autocomplete>

            </v-col>
            <v-col cols="12" md="6">
              <common-select-user
                class="btn-style-all"
                v-model="filterForm.userIds"
                :items="users"
                :showInactive="_.isEmpty(filterForm.ministryIds)"
                color="primary"
                item-text="fullName"
                item-value="id"
                placeholder="Chọn người phụ trách"
                label="Người phụ trách"
                multiple
                clearable
              />
              <template #prepend-item>
                <common-select-all
                    v-model="filterForm.userIds"
                    :item="filterForm.userIds"
                    :items="users.map(s => s.id)"
                ></common-select-all>
              </template>
            </v-col>
          </v-row>
          <div></div>
          <v-row>
            <v-col cols="12" md="6" class="py-0">
              <v-text-field placeholder="Nhập mã phiếu thu" v-model="filterForm.receiptCode" label="Mã phiếu thu" clearable />
            </v-col>
            <v-col cols="12" md="6" class="py-0">
              <common-range-picker
                :aLight="'left'"
                label="Ngày tạo phiếu thu"
                v-model="filterForm.receiptCreatedAt"
                clearable
                :defaultRange="defaultRange"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-0">
              <v-autocomplete
                v-model="filterForm.contactSourceId"
                :items="contactSources"
                item-text="name"
                item-value="id"
                label="Nguồn khách hàng"
                placeholder="Chọn nguồn khách hàng"
                clearable
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field placeholder="Nhập tên khách hàng" class="py-0" v-model="filterForm.contactName" label="Tên khách hàng" clearable />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                placeholder="Nhập số điện thoại khách hàng"
                class="py-0"
                v-model="filterForm.contactMobile"
                label="Số điện thoại khách hàng"
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field placeholder="Nhập tên con" class="py-0" v-model="filterForm.childName" label="Tên con" clearable />
            </v-col>
            <v-col cols="12" md="4" class="pt-0">
              <common-select-year
                v-model="filterForm.childBirthday"
                label="Năm sinh của con"
                placeholder="Nhập năm sinh ..."
                clearable
              />
            </v-col>            
            <v-col cols="12" md="4" class="pt-0">
              <v-autocomplete
                v-model="filterForm.statusIds"
                :items="selectContactStatusList"
                item-text="name"
                item-value="id"
                label="Mối liên hệ"
                placeholder="Chọn môi liên hệ"
                clearable
                multiple
              />
            </v-col>
          </v-row>
          <div class="d-flex text-center mb-4 justify-center">
            <v-btn class="primary mx-0" @click.prevent="handleSubmit(searchOrder)">
              <v-icon>mdi-dropdown</v-icon>Tìm kiếm
            </v-btn>
            <div  class="d-flex ml-5 group-input">
              <v-btn v-if="checkAuthorization('order_download')" class="primary mx-0 download" @click.prevent="handleSubmit(exportExcel)">
                <v-icon>mdi-download</v-icon>Download
              </v-btn>
              <template>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          class="dropdown"
                          color="#E91E63"
                          dark
                          v-bind="attrs"
                          v-on="on"
                      >
                        <v-icon>mdi-chevron-down</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(item, index) in itemsExport">
                        <v-list-item
                                :key="index"
                                v-if="(checkAuthorization('order_download') && item.code == 'DOISOAT')
                                      || (checkAuthorization('export-order-accountant_read') && item.code == 'KETOAN')
                                      || (checkAuthorization('export-order-accountant_read') && item.code == 'KETOANHOADON')"
                                @click="handleSubmit(exportExcelDoiSoat(item))"
                        >
                          <v-list-item-title>{{ item.title }}</v-list-item-title>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
              </template>
            </div>
          </div>
        </v-list-item-content>
      </validation-observer>
    </v-list-item>
  </v-card>
</template>

<style>
.download {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
}

.dropdown {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12);
  min-width: 35px !important;
  width: 30px;
  position: absolute;
  right: -30px;
}
</style>


<script>
import TokenService from '../../../helpers/token';
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import { downloadFile } from '../../../helpers/utils';
const OrganizationMachineRepository = RepositoryFactory.get('organization_machine')
const ProductGroupRepository = RepositoryFactory.get('product_group');
const ProductRepository = RepositoryFactory.get('product');
const ContactSourceRepository = RepositoryFactory.get('contact_source');
const OrderRepository = RepositoryFactory.get('order');
import {orderGroupType, typeOrderGroupPrice} from '../../../helpers/constants'
import * as moment from 'moment'

function getDefaultCreatedAt() {
  return [
    moment().subtract(30, 'days').format('YYYY-MM-DD'),
    moment().format('YYYY-MM-DD')
  ];
}

export default {
  props: {
    filterContactStatusList: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      users: [],
      ministries: [],
      productGroups: [],
      products: [],
      contactSources: [],
      paymentTypes: ['COD', 'BANK'],
      itemsExport: [
          { title: 'Đối soát', code: 'DOISOAT' },
          { title: 'Kế toán', code: 'KETOAN' },
          { title: 'Kế toán hoá đơn', code: 'KETOANHOADON' },
      ],
      listUsers: [],
      filterForm: {
        keyword: '',
        openMenu: false,
        code: '',
        departmentId: '',
        userId: '',
        orderSaleMinistryIds: [],
        userIds: [],
        groupId: '',
        productId: '',
        contactSourceId: '',
        paymentType: '',
        createdAt: getDefaultCreatedAt(),
        contactName: '',
        receiptCode: '',
        contactMobile: '',
        childName: '',
        childBirthday: '',
        statusIds: [],
        orderGroupType: null,
        typeOrderGroupPrice: 'eq',
        orderGroupPrice: null,
        receiptCreatedAt: [],
        paymentPeriod: '',
      },
      watchModule: '',
      orderGroupType,
      typeOrderGroupPrice,
      defaultRange: {},
      paymentPeriods: [{id:1, name:'Thanh toán một lần'}, {id:2, name:'Thanh toán nhiều lần'}]
    };
  },
  computed: {
    selectContactStatusList() {
      const contactStatusList = [];
      const checkType = {};
      this.filterContactStatusList.forEach(contactStatus => {
        const typeContactStatus = contactStatus.type;
        if (!checkType[typeContactStatus]) {
          checkType[typeContactStatus] = true;
          if (contactStatusList.length > 0) {
            contactStatusList.push({ divider: true });
          }
          contactStatusList.push({ header: typeContactStatus });
        }
        contactStatusList.push(contactStatus);
      });
      return contactStatusList;
    },
    disableUser() {
      return !this.checkAuthorization('order_view_all') && this.isStaff();
    },
  },
  async created() {
    const loader = this.$loading.show();
    await Promise.all([
      this.getUsers(),
      this.getProductGroups(),
      this.getContactSources(),
      this.getProducts()
    ]);
    loader.hide();

    this.watchModule = this.$store.watch(
      (state) => {
        return state.module
      },
      (newVal) => {
        this.filterForm = {
          keyword: '',
          openMenu: false,
          code: '',
          departmentId: '',
          userId: '',
          orderSaleMinistryIds: [],
          userIds: [],
          groupId: '',
          productId: '',
          contactSourceId: '',
          paymentType: '',
          createdAt: getDefaultCreatedAt(),
          contactName: '',
          receiptCode: '',
          contactMobile: '',
          childName: '',
          childBirthday: '',
          statusIds: [],
          orderGroupType: null,
          typeOrderGroupPrice: 'eq',
          orderGroupPrice: null,
          receiptCreatedAt: [],
          paymentPeriod: '',
        }
        this.getUsers()
        this.getProductGroups()
      },
      {
        deep: true
      }
    )
  },

  beforeDestroy() {
    this.watchModule()
  },

  methods: {
    closeMenu() {
      // this.filterForm.openMenu = false
      this.$emit('closeMenu')
    },
    async getContactSources() {
      const respond = await ContactSourceRepository.list({ limit: 100 });
      if (_.get(respond, 'success', false)) {
        this.contactSources = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async getProducts() {
      const respond = await ProductRepository.list({
        limit: 1000,
        groupId: this.filterForm.groupId
      });
      if (_.get(respond, 'success', false)) {
        let groupBy = _.groupBy(_.get(respond, 'data', []), 'status');
        console.log(groupBy, "groupBy")
        this.products = [
          {header: "Sản phẩm ACTIVE"},
          ..._.get(groupBy, 'active', []),
          ..._.get(groupBy, 'draft', []),
          {header: "Sản phẩm INACTIVE"},
          ..._.get(groupBy, 'inactive', []),
        ]
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    async clearProductGroup() {
      this.filterForm.groupId = ''
      const loader = this.$loading.show();
      await this.getProducts();
      loader.hide();
    },
    async onChangeProductGroup() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.productId = '';
      if (filterFormTemp.groupId) {
        const loader = this.$loading.show();
        await this.getProducts();
        loader.hide();
      }
    },
    async getProductGroups() {
      const respond = await ProductGroupRepository.list({ 
        limit: 100, 
        status: 'active',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      });
      if (_.get(respond, 'success', false)) {
        this.productGroups = _.get(respond, 'data', []);
      } else {
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: _.get(respond, 'message', '')
        });
      }
    },
    onChangeMinistry() {
      let listMinistries = this.ministries.filter(m => this.filterForm.ministryIds.includes(m.id))

      if (listMinistries) {
        listMinistries = listMinistries.map(m => m.name)
        this.users = this.listUsers.filter(u => listMinistries.includes(u.header) || listMinistries.includes(u.group))
      } else {
        this.users = _.cloneDeep(this.listUsers)
      }

      this.filterForm.userIds = []
    },
    async getUsers() {
      const res = await OrganizationMachineRepository.listUserContactAdvise({
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      })

      if (res.success) {
        let listUsers = _.get(res, 'data', [])
        const groupUsers = [];
        const listMinistries = []
        listUsers.forEach(ministry => {
          if (ministry.name != 'Inactive') {
            listMinistries.push({
              id: ministry.id,
              name: ministry.name
            })
          }

          const { users = [] } = ministry;
          if (users.length) {
            groupUsers.push({
              header: _.get(ministry, 'name'),
              name: _.get(ministry, 'name'),
              ministryId: ministry.id,
            });
            users.forEach(user => {
              groupUsers.push({
                fullName: _.get(user, 'fullName'),
                group: _.get(ministry, 'name'),
                id: user.id,
                avatar: _.get(user, 'avatar.filePath'),
                ministryId: ministry.id,
              });
            });
          }
        });
        this.users = _.cloneDeep(groupUsers);
        this.listUsers = _.cloneDeep(groupUsers);
        this.ministries = listMinistries
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    searchOrder() {
      let filterForm = _.cloneDeep(this.filterForm)
      Bus.$emit('order-list-filter', filterForm);
    },
    checkEmptyFilterForm() {
      let isExist = false;

      const isExistKeyword = !!this.filterForm.keyword;

      const isExistMinistryId = !!this.filterForm.orderSaleMinistryIds;

      const isExistUserId = !!this.filterForm.userIds;

      const isExistGroupId = !!this.filterForm.groupId;

      const isExistProductId = !!this.filterForm.productId;

      const isExistContactSourceId = !!this.filterForm.contactSourceId;

      const isExistPaymentType = !!this.filterForm.paymentType;

      const isExistCreatedAt = _.isArray(this.filterForm.createdAt) ? !!this.filterForm.createdAt.length : false;
      
      const isExistReceiptCreatedAt = _.isArray(this.filterForm.receiptCreatedAt) ? !!this.filterForm.receiptCreatedAt.length : false;

      const isExistContactName = !!this.filterForm.contactName;

      const isExistChildName = !!this.filterForm.childName;

      const isExistContactMobile = !!this.filterForm.contactMobile;

      const isExistReceiptCode = !!this.filterForm.receiptCode;

      const isExistChildBirthday = !!this.filterForm.childBirthday;

      const isExistStatusIds = _.isArray(this.filterForm.statusIds) ? !!this.filterForm.statusIds.length : false;

      const isExistpaymentPeriod = !!this.filterForm.paymentPeriod;

      isExist = isExistKeyword || isExistMinistryId || isExistUserId || isExistGroupId || isExistProductId || isExistContactSourceId || isExistPaymentType || isExistCreatedAt || isExistReceiptCreatedAt || isExistContactName || isExistChildName || isExistContactMobile || isExistChildBirthday || isExistStatusIds || isExistReceiptCode || isExistpaymentPeriod;
      return isExist;
    },
    async exportExcel() {
      if (!this.checkEmptyFilterForm()) {
        this.$swal({
        type: 'error',
        title: 'Lỗi !',
        text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
        })
        return;
      }
      const loader = this.$loading.show();
      let user = await TokenService.getUser()
      let filterForm = _.cloneDeep(this.filterForm)
      OrderRepository.exportExcelContact({...filterForm, username: user.username})
      loader.hide();
      this.$swal({
        title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
      });
      // if (_.get(response, 'success', false)) {
      //   if (response.data) {
      //     await downloadFile(_.get(response, 'data.csvFile', ''), _.get(response, 'data.fileName', ''));
      //     loader.hide();
      //   } else {
      //     this.$swal({
      //       type: 'error',
      //       title: 'Lỗi !',
      //       text: _.get(response, 'message', ''),
      //     })
      //   }
      // } else {
      //   loader.hide();
      //   this.$swal({
      //     type: 'error',
      //     title: 'Lỗi !',
      //     text: _.get(response, 'message', ''),
      //   })
      // }
    },
    async exportExcelDoiSoat(item) {
      if (!this.checkEmptyFilterForm()) {
        this.$swal({
        type: 'error',
        title: 'Lỗi !',
        text: 'Vui lòng chọn ít nhất 1 điều kiện tìm kiếm',
        })
        return;
      }
      const loader = this.$loading.show();
      let user = await TokenService.getUser()
      if(item.code == 'DOISOAT') {
          OrderRepository.exportExcelContactDoiSoat({...this.filterForm, username: user.username})
      } 
      if(item.code == 'KETOAN') {
          OrderRepository.exportExcelOrderAccountant({...this.filterForm, username: user.username})
      }
      if(item.code == 'KETOANHOADON') {
          OrderRepository.exportExcelInvoiceAccountant({...this.filterForm, username: user.username})
      }
      loader.hide();
      this.$swal({
        title: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!'
      });
    },
    changeDateRange (dateRange) {
      this.filterForm.dateRange = dateRange
    },
  }
};
</script>
<style scoped>
/deep/.v-subheader.theme--light {
    width: 100%;
    background: rgb(206, 150, 104);
  }
</style>
